import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const indicators = [
    {
      icon: 'Shield',
      label: 'Secure'
    },
    {
      icon: 'Lock',
      label: 'Encrypted'
    },
    {
      icon: 'CheckCircle',
      label: 'Trusted'
    }
  ];

  return (
    <div className="text-center">
      <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
        {indicators?.map((indicator, index) => (
          <div key={index} className="flex items-center space-x-1">
            <Icon name={indicator?.icon} size={14} color="var(--color-success)" />
            <span>{indicator?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;